
// This is used to memorize (in local storage also) the latest homepage url seen by the user.
// It's useful to link back to the homepage without losing the current calendar navigation.

const LS_HOMEPAGE_URL_KEY = 'lastHomepageUrl';

// reload from local storage on app start
export let lastHomepageUrl = localStorage.getItem(LS_HOMEPAGE_URL_KEY) || '/';

export function setHomepageUrl(url: string) {
	lastHomepageUrl = url;
	// save to local storage (to handle page reload properly)
	localStorage.setItem(LS_HOMEPAGE_URL_KEY, url);
}
